/** localStorage key that remembers `?onboarding=off` across reloads and in-app redirects. */
export const ONBOARDING_DISABLED_KEY = "artemis-onboarding-disabled";

/**
 * Whether the first-run welcome wizard and nav tour should stay closed. Meant for automated
 * sessions (Claude Code, Playwright) that would otherwise have every fresh browser profile
 * covered by the intro modals; real users never set it.
 *
 * Two switches, either one disables:
 * - `VITE_DISABLE_ONBOARDING=true` at build/dev-server time — `task up` sets it when run from a
 *   Claude Code shell, or explicitly with `ONBOARDING=off`.
 * - `?onboarding=off` on any URL, against any frontend (including a deployed one). Remembered in
 *   localStorage so it survives the router's redirects; `?onboarding=on` clears it.
 *
 * Read once at startup (main.tsx) and handed to `FlagsProvider` as `ONBOARDING_DISABLED`.
 */
export function isOnboardingDisabled(search = window.location.search): boolean {
	if (import.meta.env.VITE_DISABLE_ONBOARDING === "true") return true;
	try {
		const param = new URLSearchParams(search).get("onboarding");
		if (param === "off") localStorage.setItem(ONBOARDING_DISABLED_KEY, "1");
		if (param === "on") localStorage.removeItem(ONBOARDING_DISABLED_KEY);
		return localStorage.getItem(ONBOARDING_DISABLED_KEY) === "1";
	} catch {
		// Storage blocked (private mode, sandboxed iframe): fall back to normal onboarding.
		return false;
	}
}
